import type { ReactNode } from 'react'
import { Footer } from './Footer'
import { Header } from './Header'

/**
 * The chrome every route shares. It is a component rather than a react-router layout route so
 * a page can be rendered — and screenshotted — on its own in a test without a router tree.
 */
export function Page({ children }: { children: ReactNode }) {
  return (
    <div className="mha-page">
      <Header />
      <main className="mha-page__main">{children}</main>
      <Footer />
    </div>
  )
}
